export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`, `4XL`, `5XL`],
  [`Российский размер`, `44`, `46`, `48`, `50`, `52`, `54`, `56`, `58`, `60`],
  [`Рост`, `170`, `176`, `176`, `182`, `182`, `182`, `182`, `188`, `188`],
  [
    `Обхват груди (a)`,
    `88`,
    `92`,
    `96`,
    `100`,
    `104`,
    `108`,
    `112`,
    `116`,
    `120`
  ],
  [`Обхват талии (b)`, `72`, `76`, `80`, `84`, `88`, `92`, `96`, `100`, `104`],
  [
    `Длина спины по центру (c)`,
    `71`,
    `72`,
    `73`,
    `76`,
    `76`,
    `76`,
    `76`,
    `79`,
    `79`
  ],
  [
    `Ширина на уровне проймы (d)`,
    `53`,
    `55`,
    `57`,
    `59`,
    `61`,
    `63`,
    `65`,
    `67`,
    `69`
  ],
  [
    `Ширина рукава вверху (e)`,
    `21`,
    `22`,
    `22`,
    `23`,
    `24`,
    `25`,
    `25`,
    `26`,
    `27`
  ],
  [`Длина рукава (f)`, `66`, `69`, `69`, `72`, `72`, `72`, `73`, `75`, `75`]
];
